import EdDate from "./src/index.js";

/* istanbul ignore next */
EdDate.install = function (Vue) {
    Vue.component(EdDate.name, EdDate)
}

export default EdDate
